import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

export const getCurrentDateString = () => new Date(Date.now()).toISOString();

// Define a type for the slice state
interface OrderState {
  date: string;
  operator: number;
  selected: number[]; // day summary
}

// Define the initial state using that type
const initialState: OrderState = {
  date: new Date().toISOString(),
  operator: 0,
  selected: [],
};

export const orderSlice = createSlice({
  name: "order",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setDate: (state, action: PayloadAction<string>) => {
      state.date = action.payload;
    },
    setOperator: (state, action: PayloadAction<number>) => {
      state.operator = action.payload;
    },
    toggleSelected: (state, action: PayloadAction<number>) => {
      if (state.selected.find((id) => id === action.payload))
        state.selected = state.selected.filter((id) => id !== action.payload);
      else state.selected.push(action.payload);
    },
    clearSelected: (state) => {
      state.selected = [];
    },
  },
});

export const { setDate, toggleSelected, clearSelected, setOperator } =
  orderSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getDate = (state: RootState) => state.order.date;
export const getOperator = (state: RootState) => state.order.operator;
export const getSelected = (state: RootState) => state.order.selected;

export default orderSlice.reducer;
